import React, {PureComponent} from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/Transition';
import {TweenLite} from 'gsap'
import {isShopTheLookOpen, getShopTheLookTitle, getCurrentShopTheLookItems, isUsingUniversalMenu, showAddToBag, getScreenBreakpoint} from '../../selectors'
import {closeShopTheLookDialog} from "../../actions"
import closeImg from '../../img/icons/close.svg'
import SVGSymbol from "../SVGSymbol"
import {getScrollBarWidth} from "../../utils/measure"
import ShopTheLookCarousel from './ShopTheLookCarousel'
import theme from "../../styles/theme"

const TRANSITION_DURATION_SECONDS = 0.35;

class ShopTheLookDialog extends PureComponent {

    _close = () => {
        const {handleCloseDialog} = this.props;
        handleCloseDialog();
    }

    _stopPropagation = (e) => {
        e.stopPropagation();
    }

    _onEnteringOverlay = (node) => {
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.marginRight = getScrollBarWidth() + 'px';
        TweenLite.fromTo(node, 0.25, {opacity: 0}, {opacity: 1});
    }

    _onExitingOverlay = (node) => {
        document.documentElement.style.overflow = 'auto';
        document.documentElement.style.marginRight = 'auto';
        TweenLite.to(node, 0.25, {opacity: 0, delay: 0.1});
    }

    _onEntering = (node) => {
        TweenLite.set(node,{opacity: 0, y: 100});
        TweenLite.to(node, 0.25, {opacity: 1, y: 0, delay: 0.1});
    }

    _onExiting = (node) => {
        TweenLite.to(node, 0.25, {opacity: 0, y: 100});
    }

    render() {
        const {classes, open, title, item, is_mobile} = this.props;

        if(!item) return null;
        const portrait = item.image.desktop[0].dimensions.height > item.image.desktop[0].dimensions.width;
        // const imageAspect = portrait ? 1.5 : 0.73;
        const wideDialog = item.shopItems.length >= 3 ? true : false;

        return <div className={classes.container}>
            <TransitionGroup appear={true} enter={true} exit={true}>
            {open &&
            <Transition timeout={TRANSITION_DURATION_SECONDS*1000}
                        onEntering={this._onEnteringOverlay}
                        onExiting={this._onExitingOverlay}>
                <div className={classes.overlay}></div>
            </Transition>}
            {open &&
            <Transition timeout={TRANSITION_DURATION_SECONDS*1000}
                        onEntering={this._onEntering}
                        onExiting={this._onExiting}>
                <div className={classes.dialogWrap}>
                    <div className={classes.dialogContainer} onMouseDown={this._close} >
                        <div className={cn(classes.dialog, {[classes.dialogPortrait]: portrait}, wideDialog && classes.dialogWide)} onMouseDown={this._stopPropagation}>
                            <div className={classes.dialogToolbar}>
                                <div className={classes.dialogTitle}>
                                    <h3>{title || 'Shop the look'}</h3>
                                </div>
                                <div className={classes.dialogActions}>
                                    <a onClick={this._close}><SVGSymbol onClick={this._close} icon={closeImg} className={classes.dialogIcon}/></a>
                                </div>
                            </div>
                            <div className={classes.dialogContent}>
                                <ShopTheLookCarousel key={is_mobile} shopItems={item.shopItems} onClick={this._onCarouselClick} size="large" showTitle={false} showNextPrevButtons={true} isMobile={is_mobile} />
                                {/* {portrait && <ResponsiveImage className={cn(classes.hero, classes.heroPortrait)} images={item.image} aspect={imageAspect} setRef={this._setImageRef} blurEnabled={false}  parallax={false}/>}
                                <div className={classes.itemsContainer}>
                                    {!portrait && <ResponsiveImage className={classes.hero} images={item.image} aspect={imageAspect} setRef={this._setImageRef} blurEnabled={false}  parallax={false} />}
                                    {item && item.shopItems && item.shopItems.map((item, i) => {
                                            return <ShopTheLookItem key={i} item={item} universalMenu={universalMenu} showAddToBag={showAddToBag} classNames={classes} />
                                    })}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>}
            </TransitionGroup>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        open: isShopTheLookOpen(state),
        title: getShopTheLookTitle(state),
        item: getCurrentShopTheLookItems(state),
        universalMenu: isUsingUniversalMenu(state),
        showAddToBag: showAddToBag(state),
        is_mobile: getScreenBreakpoint(state) <= theme.breakpoints.tablet ? true : false
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleCloseDialog: () => {
            dispatch(closeShopTheLookDialog())
        }
    }
}

export default injectSheet( (theme) => (
{
    container: {
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        position: 'fixed',
        '-webkit-transform': 'translateZ(0)',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: theme.zIndex.dialog - 1
    },
    dialogWrap: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        outline: 'none',
        position: 'fixed',
        overflowX: 'hidden',
        overflowY: 'auto',
        zIndex: theme.zIndex.dialog,
    },
    dialogContainer: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '100%',
        textAlign: 'center',
        '& > div': {
            boxShadow: '0px 2px 5px rgba(0,0,0,0.1)'
        },
        '&:before': {
            content: "''",
            display: 'inline-block',
            height: '100%',
            verticalAlign: 'middle'
        }
    },
    dialog: {
        borderRadius: '5px',
        boxSizing: 'border-box',
        display: 'inline-block',
        position: 'absolute',
        verticalAlign: 'middle',
        overflow: 'hidden',
        backgroundColor: theme.colors.white,
        width: '100%',
        bottom: 0,
        left: 0,
        "&:after": {
            clear: "both",
            content: '""',
            display: "table",
            height: 20
        },
        [theme.breakpoint('tablet')]: {
            position: 'relative',
            minWidth: 478,
            width: 'auto',
            top: 0
        },
        [theme.breakpoint('laptop')]: {
            maxWidth: 688,
        }
    },
    dialogPortrait: {
        borderRadius: '5px',
        overflow: 'hidden',
        width: '100%',
        [theme.breakpoint('tablet')]: {
            minWidth: 478,
            width: 'auto'
        },
        [theme.breakpoint('laptop')]: {
            maxWidth: 688,
        }
    },
    dialogWide: {
        width: "inherit"
    },
    dialogToolbar: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing.small,
        paddingBottom: 0,
        [theme.breakpoint('tablet')]: {
            padding: theme.spacing.normal,
            paddingBottom: 0
        }
    },
    dialogTitle: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoint('tablet')]: {
            justifyContent: 'center',
        },
        '& h3': {
            color: theme.colors.black,
            fontStyle: 'normal',
            marginTop: 10,
            lineHeight: '36px',
            fontSize: '20px',
            letterSpacing: '-0.3px',
            textTransform: 'none',
            [theme.breakpoint('tablet')]: {
                fontSize: '22px',
            },
        }
    },
    dialogActions: {
        position: 'absolute',
        top: '18px',
        right: '18px',
        "& > a" : {
            width: 30,
            height: 30
        }
    },
    dialogIcon: {
        color: theme.colors.black,
        width: 14,
        height: 14,
        [theme.breakpoint('tablet')]: {
            width: 18,
            height: 18
        }
    },
    shopIcon: {
        color: theme.colors.white,
        height: 18,
        marginTop: -2,
        [theme.breakpoint('tablet')]: {
            marginTop: 1,
        },
        '& > svg': {
            width: 18,
            height: 'auto',
        }
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        margin: theme.spacing.small,
        [theme.breakpoint('tablet')]: {
            margin: theme.spacing.normal,
            alignItems: 'center'
        }
    },
    hero: {
        maxWidth: 290,
        background: '#F3F3F7',
        margin: 5,
        [theme.breakpoint('tablet')]: {
            maxWidth: 290,
        },
        [theme.breakpoint('desktop')]: {
            maxWidth: 410,
        },
    },
    heroPortrait: {
        maxWidth: 150,
        [theme.breakpoint('mobile')]: {
            maxWidth: 200,
        },
        [theme.breakpoint('mobile')]: {
            maxWidth: 290,
        },
    },
    itemsContainer: {
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',
        width: '100%',
        overflowX: 'scroll',
        [theme.breakpoint('tablet')]: {
            justifyContent: 'center'
        }
    }
}))(connect(mapStateToProps, mapDispatchToProps)(ShopTheLookDialog))





// WEBPACK FOOTER //
// ./src/components/ShopThLook/ShopTheLookDialog.js